module.exports = __webpack_public_path__ + "static/media/32.41039826.jpeg";